import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon, Loader } from 'semantic-ui-react';

const ActionBar = styled.div`
    width: 100%;
    height: 60px;
    margin-top: 3px;
    margin-bottom: -10px;
    border-radius: 5px;
    border-left:1px solid #FFF;
    border-right:1px solid #FFF;
    border-top:1px solid #FFF;
    background-color: ${props => (props.active ? props.theme.colors.goodwayBlue : props.theme.colors.gray)};
    display: flex;
    flex-direction: row;
`;
const ActionsContainer = styled.div`
    width: 90%;
    overflow-x: auto;
    display: flex;
    flex-direction: row;
`;
const SelectedCount = styled.div`
    color: #FFF;
    border-right: 1px solid #FFF;
    width: 10%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 15px;
    font-weight: 900;
`;
const IconContainer = styled.div`
    font-size: 20px;
    cursor: ${props => (props.loading ? 'initial' : 'pointer')};
    width: 85px;
    border-right: 1px solid #FFF;
    color: ${props => (props.color ? props.color : '#FFF')};
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 5px;

    &:hover { color: ${props => props.theme.colors.yellow}; }
`;
const IconLabel = styled.div`
    font-size: 10px;
    margin-top: 3px;
    line-height: 1;
    text-align: center;
    text-transform: uppercase;
    font-weight: 600;
`;

const IconWithWords = ({ icon, onClick, name, ...rest }) => (
    <IconContainer onClick={onClick} {...rest}>
        <Icon name={icon} />
        <IconLabel>{name}</IconLabel>
    </IconContainer>
);
const Actions = ({ groupId, groupType, tableProps = {}, actions, tableRows, alwaysShowActionBar }) => {
    const [loadingIds, setLoadingIds] = useState([]);
    const [completeIds, setCompleteIds] = useState([]);
    const [failedIds, setFailedIds] = useState([]);
    const selected = tableProps.getGroupSelectedRows(groupId);
    const rows = selected.length ? selected.map(y => y.original) : tableRows.map(y => y.original);
    const createRowData = row => ({
        row,
        groupType: groupType || null,
        selectedCount: selected.length,
        rows,
        groupId: groupId === '' ? 'unmapped' : groupId
    });

    const addToLoading = (id, shouldHide) => {
        if (shouldHide) {
            return null;
        }
        setLoadingIds(prev => [...prev, id]);
        return true;
    };
    const removeFromLoading = (id, wasSuccessful, shouldHide) => {
        if (shouldHide) {
            return null;
        }
        setLoadingIds(prev => prev.filter(x => x !== id));
        const setter = wasSuccessful ? setCompleteIds : setFailedIds;
        setter(prev => [...prev, id]);
        setTimeout(() => {
            setter(prev => prev.filter(x => x !== id));
        }, 5000);
        return true;
    };
    const checkIsComplete = id => !!completeIds.find(x => x === id);
    const checkIsFailed = id => !!failedIds.find(x => x === id);
    const checkIsLoading = id => !!loadingIds.find(x => x === id);
    const actionsToShow = actions.filter((x) => {
        if (selected.length) {
            return selected.every(y => x.limiter(createRowData(y.original)));
        }
        return x.limiter(createRowData({}));
    });
    const isActive = !!actionsToShow.length;
    const showActionBar = alwaysShowActionBar ? true : isActive;
    const selectionText = `${selected.length} Selected`;
    return (
        showActionBar && <ActionBar active={isActive}>
            <SelectedCount>{selectionText}</SelectedCount>
            {isActive && <ActionsContainer>
                {actionsToShow.map((x) => {
                    if (checkIsFailed(x.id)) {
                        return <IconContainer key={x.id} color="#ff7575" loading><Icon name="exclamation circle"></Icon></IconContainer>;
                    } else if (checkIsComplete(x.id)) {
                        return <IconContainer key={x.id} color="#9cff75" loading><Icon name="check circle"></Icon></IconContainer>;
                    }
                    if (x.customRender) {
                        return x.customRender({
                            id: x.id,
                            icon: <IconWithWords icon={x.icon} name={x.name}/>,
                            rows,
                            table: tableProps,
                            setLoading: () => addToLoading(x.id, x.hideLoader),
                            clearSelections: () => tableProps.removeGroupSelections(groupId),
                            setFinished: wasSuccessful => removeFromLoading(x.id, wasSuccessful, x.hideLoader)
                        });
                    }
                    return checkIsLoading(x.id) ? <IconContainer key={x.id} loading><Loader inline inverted active size='small'/></IconContainer> : (<IconWithWords key={x.id} icon={x.icon} name={x.name} onClick={async () => {
                        addToLoading(x.id, x.hideLoader);
                        try {
                            await x.action({ rows, table: tableProps });
                            removeFromLoading(x.id, true, x.hideLoader);
                            if (x.shouldClearSelections) {
                                tableProps.removeGroupSelections(groupId);
                            }
                        } catch (e) {
                            removeFromLoading(x.id, false, x.hideLoader);
                        }
                    }}/>);
                }
                )}
            </ActionsContainer>}
        </ActionBar>
    );
};
export default Actions;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/tablePlugins/Actions.js